import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const Navbar = () => {
  return (
    <div>
      <nav class="navbar navbar-expand-sm bg-body-tertiary">
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            G2 Radio Network
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div class="navbar-nav">
              <NavLink to="/" class="nav-link active" aria-current="page">
                Home
              </NavLink>
              <span
                class="tt"
                data-bs-placement="bottom"
                title="Click Here To Listen"
              >
                <NavLink to="LaMesa" class="nav-link">
                  La Mesa Station
                </NavLink>
              </span>
              <NavLink to="AboutUs" class="nav-link">
                About Us
              </NavLink>
              <NavLink to="Contact" class="nav-link">
                Contact
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Navbar;
